let state = {
    
    loading: false,
    pdf: false,
   

}

export default state